export enum MediaType {
  Image = 'image',
  Video = 'video',
}

export interface Media {
  type: MediaType;
  src: string;
  poster?: string;
  alt?: string;
}

export interface WireMediaRef {
  uuid?: string;
  url: string;
  type?: string;
  format?: 'IMAGE' | 'VIDEO' | 'PDF';
  posterUrl?: string;
}

export function mediaFromWire(ref: WireMediaRef | undefined, alt?: string): Media | undefined {
  if (!ref?.url) {
    return undefined;
  }
  if (ref.format === 'VIDEO') {
    return {type: MediaType.Video, src: ref.url, alt, poster: ref.posterUrl};
  }
  return {type: MediaType.Image, src: ref.url, alt};
}
